<template>
    <!-- <v-content> -->
        <div class="containter">

        
         <v-container  >
            <!-- <v-layout align-center justify-center > -->
               <!-- <v-flex xs12 sm8 md4> -->
                <v-sheet :elevation="10"  width="400" >
                     <!-- <v-toolbar dark color="#008080">
                        <v-toolbar-title>Login form</v-toolbar-title>
                     </v-toolbar> -->
                     <!-- <v-card> -->
                        <div style="width: 100;">
                            <img src="https://www.edisac.com/images/photolib_la/Header-com_mb.jpg" alt="" />
                        </div>
                     <!-- </v-card> -->
                     <v-divider></v-divider>
                     <v-card-text>
                        <v-form action="" @submit.prevent="logIn()">
                           <v-text-field variant="outlined"
                              name="login"
                              label="Nom d'utilisateur"
                              type="text"
                              v-model="login"
                              :style="[user&&user.statut=='username'?{'color':'red'}:'']"
                           ></v-text-field>
                           <v-text-field variant="outlined"
                              id="password"
                              name="password"
                              label="Mot de passe"
                              type="password"
                              v-model="password"
                              :style="[user&&user.statut?{'color':'red'}:'']"
                           ></v-text-field>
                        </v-form>
                     </v-card-text>
                     <v-card-actions>
                        <small v-if="message" style="color:red;margin-left: 0.5em;" >{{message}}</small>
                        <v-spacer></v-spacer>
                        <v-btn color="#008080" @click="logIn()" :disabled="login&&password?false:true" type="submit">Login</v-btn>
                        
                     </v-card-actions>
                        <v-card-actions v-if="user&&user.statut=='password'">
                            <a style="margin-left: 0.5em;" class="mdp" @click="sendEmail();dialogLogIn=true"><small class="mdp"> mot de passe oublié?</small></a>
                        </v-card-actions> 

                     
                  </v-sheet>

         </v-container>
        </div>

        <v-dialog
            v-model="dialogLogIn"
            width="auto"
        >
            <v-card
            max-width="400"
            :text="`${user.name}, le mot de passe a été envoyé à l'adresse ${user.email}`"
            >
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogLogIn = false"
                ></v-btn>
            </template>
            </v-card>
        </v-dialog>
</template>
<script setup>
import axios from 'axios'
import { ref } from 'vue';
import store from './store';
import router from './router'

let login=ref()
let password=ref()
let dialogLogIn=ref()
let message=ref()
let user=ref()
const getURL=(user)=>{
    let url=''
    switch (user.groupe) {
        case 'A':   url='/fripe'
        break;
        case 'B':   url='/validation'
        break;
        case 'C':   url='/reception'
        break;
        default:
        break;
    }
    // console.log(url)
    return url
}
const logIn=()=>{
    let data = JSON.stringify({
        "username": login.value.toLowerCase(),
        "password": password.value
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/login',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
    .then((response) => {
        // console.log(response.data);
        if(response.data.statut=='connected'){
            store.commit('addUser',response.data)
            router.replace({ path: getURL(store.state.user) })
        }else if(response.data.statut=='username'){
            message.value=`Le nom d'utilisateur <${login.value}> n'existe pas`
            user.value=response.data
        }else if(response.data.statut=='password'){
            message.value=`${response.data.name}, le mot de passe n'est pas correcte`
            user.value=response.data
        }
    })
    .catch((error) => {
        console.log(error);
    });
}

const sendEmail=()=>{
    let data = user.value;

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/mdp',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
    .then((response) => {
    
    })
    .catch((error) => {
        console.log(error);
    });
}

</script>
<style scoped>
  .mdp {
    color:"#008080";
    cursor: pointer;
  }
  .mdp:hover{
    /* background-color: red; */
    color:green;
  }
</style>